module.exports = __webpack_public_path__ + "static/media/image-profile.2299a69e.jpg";